<template>
  <ECharts :autoresize="true" :options="options"></ECharts>
</template>

<script>
import ECharts from "vue-echarts/components/ECharts.vue";
import "echarts/lib/chart/bar";
// import 'echarts/lib/component/tooltip';
import "echarts/lib/component/title";
import "echarts/lib/component/markLine";
import "echarts/lib/component/markPoint";

export default {
  components: {
    ECharts,
  },
  data() {
    return {
      options: {},
    };
  },
  props: {
    hdata: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: "",
    },
  },
  watch: {
    hdata() {
      this.getInit();
    },
  },
  created() {
    this.getInit();
  },
  methods: {
    getInit() {
      var arr = [];
      var years = [];

      if (this.hdata) {
        if (this.hdata.Years) {
          years = this.hdata.Years;
        }
        for (let i = 0; i < this.hdata.Models.length; i++) {
          var model = this.hdata.Models[i];
          arr.push({
            name: model,
            type: "bar",
            stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: this.hdata.Numbers[i], //同型号各年份数据，从小到大
          });
        }
        const opt = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
          },
          legend: {},
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: {
            type: "value",
          },
          yAxis: {
            type: "category",
            data: years,
          },
          color: [
            "#2ec7c9",
            "#b6a2de",
            "#5ab1ef",
            "#ffb980",
            "#d87a80",
            "#8d98b3",
            "#e5cf0d",
            "#97b552",
            "#95706d",
            "#dc69aa",
            "#07a2a4",
            "#9a7fd1",
            "#588dd5",
            "#f5994e",
            "#c05050",
            "#59678c",
            "#c9ab00",
            "#7eb00a",
            "#6f5553",
            "#c14089",
          ],
          series: arr,
        };
        this.options = opt;
      }
    },
  },
};
</script>

<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
* {
  -webkit-user-select: text !important;
  user-select: text !important;
}
</style>
